import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Button from '@mui/material/Button';
import { useUser } from "../../contexts/UserContext";
import Loading from "../components/Loading";
import AlertError from "../components/AlertError";
import ModalRecuperarSenha from "../components/ModalRecuperarSenha";
import AlertSuccess from "../components/AlertSuccess";
import { gerarLinkWhatsApp } from "../../utils/WhatsappLink";

const fieldSx = {
    "& .MuiOutlinedInput-root": {
        backgroundColor: "#f9fafb",
        borderRadius: "12px",
        "& fieldset": { borderColor: "#e5e7eb" },
        "&:hover fieldset": { borderColor: "#cbd5e1" },
        "&.Mui-focused": { backgroundColor: "#fff" },
        "&.Mui-focused fieldset": { borderColor: "#0b243d", borderWidth: "2px" },
    },
    "& .MuiInputLabel-root.Mui-focused": { color: "#0b243d" },
};

const Login = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [email, setEmail] = useState("");
    const [senha, setSenha] = useState("");
    const [openSnackbarError, setOpenSnackbarError] = useState(false);
    const [mensagem, setMensagem] = useState("");
    const [open, setOpen] = useState(false);
    const [openRecuperarSenha, setOpenRecuperarSenha] = useState(false);
    const [openSnackbarSuccess, setOpenSnackbarSuccess] = useState(false);

    const { fetchUser } = useUser();

    const navigate = useNavigate();

    const handleLoginSubmit = async () => {
        setOpen(true);
        console.log("Submitting login with:", { email, senha });

        const response = await axios.post(`${process.env.REACT_APP_API_URL}/login`, { email, senha });
        console.log(response)
        if (response.data.status === 200) {
            const { token, usuario } = response.data;
            localStorage.setItem("token", token);
            localStorage.setItem("email", usuario.Email);
            await fetchUser();
            setOpen(false);
            navigate("../Dashboard");
        } else {
            setOpen(false);
            setMensagem("E-mail ou senha incorreto.")
            setOpenSnackbarError(true)
        }

    };

    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => event.preventDefault();
    const handleMouseUpPassword = (event) => event.preventDefault();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Fundo em tela cheia (sem header/footer, experiência de app) */}
            <Box
                sx={{
                    position: "relative",
                    minHeight: "100svh",
                    width: "100%",
                    display: "flex",
                    alignItems: { xs: "stretch", sm: "center" },
                    justifyContent: "center",
                    background: "linear-gradient(135deg, #0b243d 0%, #12365a 100%)",
                    p: { xs: 0, sm: 3 },
                    boxSizing: "border-box",
                    overflow: "hidden",
                }}
            >
                {/* Detalhes decorativos */}
                <Box
                    sx={{
                        display: { xs: "none", sm: "block" },
                        position: "absolute",
                        top: -180,
                        right: -180,
                        width: 420,
                        height: 420,
                        borderRadius: "50%",
                        border: "64px solid #ffc845",
                        opacity: 0.1,
                        pointerEvents: "none",
                    }}
                />
                <Box
                    sx={{
                        display: { xs: "none", sm: "block" },
                        position: "absolute",
                        bottom: -200,
                        left: -200,
                        width: 460,
                        height: 460,
                        borderRadius: "50%",
                        border: "64px solid #ffffff",
                        opacity: 0.04,
                        pointerEvents: "none",
                    }}
                />

                {/* Caixa de login */}
                <Box
                    sx={{
                        position: "relative",
                        zIndex: 1,
                        width: "100%",
                        maxWidth: { sm: "440px" },
                        display: "flex",
                        flexDirection: "column",
                        backgroundColor: "#fff",
                        borderRadius: { xs: 0, sm: "28px" },
                        overflow: "hidden",
                        boxShadow: { sm: "0 30px 80px rgba(0, 0, 0, 0.45)" },
                    }}
                >
                    {/* Topo com a marca */}
                    <Box
                        sx={{
                            position: "relative",
                            overflow: "hidden",
                            background: "linear-gradient(135deg, #0b243d 0%, #12365a 100%)",
                            color: "#fff",
                            px: 3,
                            pt: { xs: 3, sm: 3.5 },
                            pb: { xs: 6, sm: 6 },
                            textAlign: "center",
                        }}
                    >
                        <Box
                            sx={{
                                position: "absolute",
                                top: -60,
                                right: -60,
                                width: 160,
                                height: 160,
                                borderRadius: "50%",
                                border: "28px solid #ffc845",
                                opacity: 0.18,
                            }}
                        />

                        {/* Voltar para o site */}
                        <Box sx={{ position: "relative", display: "flex", justifyContent: "flex-start" }}>
                            <Button
                                startIcon={<ArrowBackIcon sx={{ fontSize: "18px !important" }} />}
                                onClick={() => navigate("/")}
                                sx={{
                                    textTransform: "none",
                                    fontSize: 13,
                                    fontWeight: 600,
                                    color: "rgba(255, 255, 255, 0.75)",
                                    borderRadius: "10px",
                                    px: 1.25,
                                    ml: -1.25,
                                    "&:hover": { color: "#fff", backgroundColor: "rgba(255, 255, 255, 0.08)" },
                                }}
                            >
                                Voltar ao site
                            </Button>
                        </Box>

                        <Box
                            component="img"
                            src="/assets/logoClarea01.png"
                            alt="Clarea Vital"
                            onClick={() => navigate("/")}
                            sx={{ position: "relative", height: { xs: 56, sm: 64 }, mt: 2, cursor: "pointer" }}
                        />
                        <Box sx={{ position: "relative", mt: 1.5, fontSize: "0.9rem", color: "rgba(255, 255, 255, 0.75)" }}>
                            A contabilidade para quem cuida da saúde.
                        </Box>
                    </Box>

                    {/* Formulário (sobe sobre o topo, como em apps) */}
                    <Box
                        component="form"
                        noValidate
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleLoginSubmit();
                        }}
                        sx={{
                            position: "relative",
                            flex: 1,
                            mt: -3,
                            backgroundColor: "#fff",
                            borderRadius: "24px 24px 0 0",
                            px: { xs: 3, sm: 4 },
                            pt: 4,
                            pb: { xs: 4, sm: 4 },
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <Box sx={{ fontSize: "1.6rem", fontWeight: 800, color: "#0b243d", letterSpacing: "-0.3px" }}>
                            Bem-vindo de volta
                        </Box>
                        <Box sx={{ mt: 0.5, mb: 3, fontSize: "0.95rem", color: "#6b7280" }}>
                            Acesse sua conta para acompanhar sua contabilidade.
                        </Box>

                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                            <TextField
                                variant="outlined"
                                type="email"
                                name="email"
                                label="E-mail"
                                placeholder="seuemail@exemplo.com"
                                autoComplete="email"
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                fullWidth
                                sx={fieldSx}
                                slotProps={{
                                    input: {
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <EmailOutlinedIcon sx={{ fontSize: 20, color: "#9ca3af" }} />
                                            </InputAdornment>
                                        ),
                                    },
                                }}
                            />
                            <TextField
                                variant="outlined"
                                name="senha"
                                label="Senha"
                                autoComplete="current-password"
                                type={showPassword ? 'text' : 'password'}
                                onChange={(e) => setSenha(e.target.value)}
                                required
                                fullWidth
                                sx={fieldSx}
                                slotProps={{
                                    input: {
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <LockOutlinedIcon sx={{ fontSize: 20, color: "#9ca3af" }} />
                                            </InputAdornment>
                                        ),
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    onMouseUp={handleMouseUpPassword}
                                                    edge="end"
                                                    aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
                                                >
                                                    {showPassword ? <VisibilityOff sx={{ fontSize: 20 }} /> : <Visibility sx={{ fontSize: 20 }} />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    },
                                }}
                            />
                        </Box>

                        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
                            <Button
                                onClick={() => setOpenRecuperarSenha(true)}
                                sx={{ textTransform: "none", fontSize: 13, fontWeight: 700, color: "#c8961e", px: 1, mr: -1, "&:hover": { backgroundColor: "rgba(200, 150, 30, 0.08)" } }}
                            >
                                Esqueceu a senha?
                            </Button>
                        </Box>

                        <Button
                            type="submit"
                            variant="contained"
                            fullWidth
                            sx={{
                                mt: 2,
                                py: 1.6,
                                fontSize: "1rem",
                                fontWeight: 700,
                                textTransform: "none",
                                backgroundColor: "#ffc845",
                                color: "#0b243d",
                                borderRadius: "12px",
                                boxShadow: "0 8px 24px rgba(255, 200, 69, 0.4)",
                                transition: "all 0.2s ease",
                                '&:hover': {
                                    backgroundColor: "#e9b53d",
                                    boxShadow: "0 10px 28px rgba(255, 200, 69, 0.5)",
                                },
                            }}
                        >
                            Entrar
                        </Button>

                        {/* Divisor */}
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, my: 3, color: "#9ca3af", fontSize: 13 }}>
                            <Box sx={{ flex: 1, height: "1px", backgroundColor: "#e5e7eb" }} />
                            Primeira vez aqui?
                            <Box sx={{ flex: 1, height: "1px", backgroundColor: "#e5e7eb" }} />
                        </Box>

                        <Button
                            variant="outlined"
                            fullWidth
                            endIcon={<ArrowForwardIcon />}
                            onClick={() => navigate("../Planos")}
                            sx={{
                                py: 1.4,
                                fontSize: "0.95rem",
                                fontWeight: 700,
                                textTransform: "none",
                                color: "#0b243d",
                                borderColor: "rgba(11, 36, 61, 0.25)",
                                borderRadius: "12px",
                                "&:hover": { borderColor: "#0b243d", backgroundColor: "rgba(11, 36, 61, 0.04)" },
                            }}
                        >
                            Conhecer os planos
                        </Button>
                        <Box sx={{ mt: 1.25, textAlign: "center", fontSize: 12.5, color: "#6b7280" }}>
                            Escolha um plano e cadastre-se em poucos minutos.
                        </Box>

                        {/* Ajuda */}
                        <Box sx={{ mt: "auto", pt: 4, display: "flex", justifyContent: "center" }}>
                            <Box
                                component="a"
                                href={gerarLinkWhatsApp("Olá! Estou com dificuldade para acessar minha conta na Clarea.")}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 0.75,
                                    fontSize: 13,
                                    fontWeight: 600,
                                    color: "#6b7280",
                                    textDecoration: "none",
                                    "&:hover": { color: "#0b243d" },
                                }}
                            >
                                <WhatsAppIcon sx={{ fontSize: 18, color: "#25D366" }} />
                                Precisa de ajuda? Fale com a gente
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>

            <Loading open={open} />
            <AlertError setOpenSnackbarError={setOpenSnackbarError} openSnackbarError={openSnackbarError} mensagem={mensagem} />
            <AlertSuccess setOpenSnackbarSuccess={setOpenSnackbarSuccess} openSnackbarSuccess={openSnackbarSuccess} mensagem={mensagem} />
            <ModalRecuperarSenha setOpenSnackbarSuccess={setOpenSnackbarSuccess} openRecuperarSenha={openRecuperarSenha} setOpenRecuperarSenha={setOpenRecuperarSenha} setOpenSnackbarError={setOpenSnackbarError} openSnackbarError={openSnackbarError} mensagem={mensagem} setMensagem={setMensagem} />
        </>
    );
};

export default Login;
